"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.setUserPostalCodeInDealerCache = exports.setParamsForClickshopUrl = exports.setDealerPostalCodeInDealerCache = exports.setCachedDealerSearch = exports.getCachedDealerSearch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEALER_CACHE_KEY = 'cSL_csDL';
var defaultState = {
  userPostalCode: '',
  dealerPostalCode: ''
};
var localStorage = typeof window !== 'undefined' && window.localStorage;
var getCachedDealerSearch = exports.getCachedDealerSearch = function getCachedDealerSearch() {
  if (!localStorage || !localStorage.getItem(DEALER_CACHE_KEY)) {
    return defaultState;
  }
  return JSON.parse(localStorage.getItem(DEALER_CACHE_KEY));
};
var setCachedDealerSearch = exports.setCachedDealerSearch = function setCachedDealerSearch(data) {
  if (!localStorage) {
    return;
  }
  if (data) {
    return localStorage.setItem(DEALER_CACHE_KEY, JSON.stringify(data));
  }
  localStorage.removeItem(DEALER_CACHE_KEY);
};
var setUserPostalCodeInDealerCache = exports.setUserPostalCodeInDealerCache = function setUserPostalCodeInDealerCache(userPostalCode) {
  var cachedDealerSearch = getCachedDealerSearch();
  var dealerInfo = _objectSpread(_objectSpread({}, cachedDealerSearch), {}, {
    userPostalCode: userPostalCode
  });
  setCachedDealerSearch(dealerInfo);
};
var setDealerPostalCodeInDealerCache = exports.setDealerPostalCodeInDealerCache = function setDealerPostalCodeInDealerCache(dealerPostalCode) {
  var cachedDealerSearch = getCachedDealerSearch();
  var dealerInfo = _objectSpread(_objectSpread({}, cachedDealerSearch), {}, {
    dealerPostalCode: dealerPostalCode
  });
  setCachedDealerSearch(dealerInfo);
};
var setParamsForClickshopUrl = exports.setParamsForClickshopUrl = function setParamsForClickshopUrl(url) {
  var formattedUrl = new URL(url);
  if (!formattedUrl.searchParams.get('location')) {
    var cachedDealerQuery = getCachedDealerSearch();
    var postalCode = cachedDealerQuery.dealerPostalCode ? cachedDealerQuery.dealerPostalCode : cachedDealerQuery.userPostalCode;
    if (postalCode) {
      formattedUrl.searchParams.set('location', postalCode);
      formattedUrl.hash = 'openDealershipFilter';
    }
  }
  return formattedUrl;
};